import React from 'react';
import styles from './ErrorMessage.module.css';
import { ButtonText } from '@oolio-group/design-ui-react';

export const ErrorMessage: React.FC<{
  message: string;
  onRetry?: () => void;
}> = ({ message, onRetry }) => {
  return (
    <div className={styles.errorMessage}>
      <p className={styles.errorText}>{message}</p>
      {onRetry && <ButtonText onClick={onRetry} label="Retry" size="small" />}
    </div>
  );
};
